/** WordPress 出力の絶対URL（:8001 等）を、今開いているオリジン（:3000 等）に合わせる */
function toCurrentOriginUrl(url) {
  const parsed = new URL(url, window.location.href);
  return `${window.location.origin}${parsed.pathname}${parsed.search}${parsed.hash}`;
}

function getBlogArchiveRoot() {
  return (
    document.querySelector('[data-blog-archive-root]') ||
    document.querySelector('.p-blog .blog-archive-main')
  );
}

function getArchiveContent(root) {
  return root.querySelector('[data-blog-archive-content]');
}

function scrollToUrlHash(url) {
  const hash = new URL(url, window.location.href).hash;
  if (!hash) {
    return;
  }

  const target = document.querySelector(hash);
  if (target) {
    target.scrollIntoView({ block: 'start' });
  }
}

function resolveImageSrc(src) {
  if (!src) {
    return '';
  }
  return toCurrentOriginUrl(src);
}

/** fetch 差し替え前に画像を読み込み、DOM 挿入後も確実に表示する */
function preloadArchiveImages(panel) {
  const tasks = [...panel.querySelectorAll('img')].map((img) => {
    const resolvedSrc = resolveImageSrc(img.getAttribute('src'));
    if (!resolvedSrc) {
      return Promise.resolve();
    }

    img.removeAttribute('loading');
    img.removeAttribute('fetchpriority');
    img.setAttribute('src', resolvedSrc);

    if (img.complete && img.naturalWidth > 0) {
      return Promise.resolve();
    }

    return new Promise((resolve) => {
      const loader = new Image();
      loader.onload = () => {
        img.src = resolvedSrc;
        resolve();
      };
      loader.onerror = () => resolve();
      loader.src = resolvedSrc;
    });
  });

  return Promise.all(tasks);
}

async function loadBlogArchiveContent(url, root, options = {}) {
  const { updateHistory = true, scrollToHash = false } = options;
  const requestUrl = toCurrentOriginUrl(url);
  const currentPanel = getArchiveContent(root);

  if (!currentPanel) {
    window.location.href = requestUrl;
    return;
  }

  root.classList.add('is-blog-loading');
  const scrollX = window.scrollX;
  const scrollY = window.scrollY;

  try {
    const response = await fetch(requestUrl, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
    });

    if (!response.ok) {
      throw new Error(`Blog archive fetch failed: ${response.status}`);
    }

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const nextPanel = doc.querySelector('[data-blog-archive-content]');

    if (!nextPanel) {
      throw new Error('Blog archive content not found in response');
    }

    const importedPanel = document.importNode(nextPanel, true);
    await preloadArchiveImages(importedPanel);
    currentPanel.replaceWith(importedPanel);

    if (updateHistory) {
      const historyUrl = new URL(requestUrl);
      history.replaceState(
        null,
        '',
        `${historyUrl.pathname}${historyUrl.search}${historyUrl.hash}`
      );
    }

    if (scrollToHash) {
      scrollToUrlHash(requestUrl);
    } else {
      window.scrollTo(scrollX, scrollY);
    }
  } catch {
    window.location.href = requestUrl;
  } finally {
    root.classList.remove('is-blog-loading');
  }
}

export function initBlogArchive() {
  const root = getBlogArchiveRoot();
  if (!root || root.dataset.blogArchiveBound === '1') {
    return;
  }

  root.dataset.blogArchiveBound = '1';

  root.addEventListener(
    'click',
    (event) => {
      const pagerLink = event.target.closest('.blogPager-num[href]');
      if (!pagerLink || !root.contains(pagerLink)) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      loadBlogArchiveContent(pagerLink.href, root, { scrollToHash: true });
    },
    true
  );
}

if (!window.__blogArchivePopstateBound) {
  window.__blogArchivePopstateBound = true;
  window.addEventListener('popstate', () => {
    const root = getBlogArchiveRoot();
    if (!root || !document.querySelector('.p-blog')) {
      return;
    }
    loadBlogArchiveContent(window.location.href, root, { updateHistory: false });
  });
}

initBlogArchive();
document.addEventListener('swup:replaced', initBlogArchive);
